import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export const PricingSection = () => {
  const plans = [{
    name: 'Starter',
    price: '$199',
    period: '/month',
    description: 'Perfect for small teams hiring occasionally',
    features: ['Up to 5 active job postings', 'Basic sales aptitude assessment', 'Email support', 'Candidate tracking', 'Basic reporting'],
    notIncluded: ['Advanced AI screening', 'Custom assessment creation', 'API access'],
    cta: 'Start Free Trial',
    ctaLink: '/signup?plan=starter',
    highlight: false
  }, {
    name: 'Professional',
    price: '$499',
    period: '/month',
    description: 'Ideal for growing sales teams',
    features: ['Up to 15 active job postings', 'Advanced sales aptitude assessment', 'AI-powered candidate screening', 'Collaborative hiring tools', 'Advanced reporting & analytics', 'Priority email & chat support', 'Interview scheduling'],
    notIncluded: ['API access'],
    cta: 'Start Free Trial',
    ctaLink: '/signup?plan=professional',
    highlight: true
  }, {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'For large organizations with complex needs',
    features: ['Unlimited job postings', 'Custom sales assessments', 'Advanced AI screening & ranking', 'Dedicated account manager', 'API access & integrations', 'Custom reporting', 'White-labeling options', 'Phone, email & chat support'],
    notIncluded: [],
    cta: 'Contact Sales',
    ctaLink: '/contact-sales',
    highlight: false
  }];
  return <section id="pricing" className="py-16 md:py-24 bg-gray-50" data-id="element-190">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-193">
            Simple, transparent pricing
          </h2>
          <p className="text-xl text-gray-600" data-id="element-194">
            Choose the plan that fits your sales hiring needs
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-195">
          {plans.map((plan, index) => <div key={index} className={`bg-white rounded-lg overflow-hidden ${plan.highlight ? 'ring-2 ring-blue-500 shadow-lg transform md:-translate-y-4' : 'border border-gray-200 shadow-sm'}`} data-id="element-196">
              {plan.highlight && <div className="bg-blue-500 text-white text-center py-2 text-sm font-medium" data-id="element-197">
                  MOST POPULAR
                </div>}
              <div className="p-6" data-id="element-198">
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-199">
                  {plan.name}
                </h3>
                <div className="flex items-end mb-4" data-id="element-200">
                  <span className="text-4xl font-bold text-gray-900" data-id="element-201">
                    {plan.price}
                  </span>
                  <span className="text-gray-600 ml-1" data-id="element-202">{plan.period}</span>
                </div>
                <p className="text-gray-600 mb-6" data-id="element-203">{plan.description}</p>
                <ul className="space-y-3 mb-8" data-id="element-204">
                  {plan.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-205">
                      <CheckIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-206" />
                      <span className="text-gray-700" data-id="element-207">{feature}</span>
                    </li>)}
                  {plan.notIncluded.map((feature, i) => <li key={i} className="flex items-start text-gray-400" data-id="element-208">
                      <XIcon className="h-5 w-5 text-gray-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-209" />
                      <span data-id="element-210">{feature}</span>
                    </li>)}
                </ul>
                <a href={plan.ctaLink} className={`block w-full py-3 px-4 text-center rounded-md font-medium ${plan.highlight ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-white text-blue-600 border border-blue-200 hover:border-blue-300'} transition-colors`} data-id="element-211">
                  {plan.cta}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};